import React from "react";
import { useEffect } from "react";
// Query-based imports
import { useQuery } from "@tanstack/react-query";
import axios from 'axios';
import useWebSocket from "../wsHook";
// defs
import { CarLocate } from "../atoms/carLocationsAtom";    
// states
import { useAtom } from 'jotai';
import { carLocationsAtom } from "../atoms/carLocationsAtom";
// import { allCarsAtom } from "../atoms/allCarsAtom";
import ConvertTime from "../converters/timestampConverter";
// visuals
import AllCarUserTable from "../charts-graphs/allCarUser-table";


export default function CarLocateHandler() {
  const [, setCarLocations] = useAtom(carLocationsAtom);
  // const [carState] = useAtom(allCarsAtom);
  const { messages } = useWebSocket<CarLocate>(['location']);

  const { isFetching, isError, error } = useQuery({
    queryKey: ['carLocate'],
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    queryFn: async () => {
      const response = await axios.get<CarLocate[]>('https://go-ev.net/api/carLocate');
      const data = response.data;
      const processedData = data
        .filter((item: CarLocate) => item.CarNumber != null)
        .map((item: CarLocate) => ({
          ...item,
          Timestamp: ConvertTime(item.Timestamp)
        }));

      setCarLocations([]);
      setCarLocations(processedData);
      console.log("processedData", processedData);
      return processedData;
    }
  });

  useEffect(() => {
    messages.forEach((messageObj) => {
      const { channel, message } = messageObj;
      if (channel === 'location') {
        try {
          const wsData = message;
          console.log("message received", wsData);

          if (wsData && wsData.Lat != null && wsData.Long != null && wsData.UID != null) {
            const newCarLocation = {
              ...wsData,
              Timestamp: ConvertTime(wsData.Timestamp)
            };

            setCarLocations((prevCarLocations) => {
              if (!prevCarLocations) return prevCarLocations;
              
              // Check if this UID exists in the current locations
              const existingLocation = prevCarLocations.find(loc => loc.UID === newCarLocation.UID);
              if (!existingLocation) {
                console.log('Received location for unknown UID:', newCarLocation.UID);
                return prevCarLocations;
              }
              
              return prevCarLocations.map(loc => 
                loc.UID === newCarLocation.UID ? newCarLocation : loc
              );
            });
          } else {
            console.warn('Received data with invalid or incomplete location info:', wsData);
          }
        } catch (err) {
          console.error('Error parsing message:', err);
        }
      }
    });
  }, [messages, setCarLocations]);

  // Render loading or Error
  const renderLoadingOrError = () => {
    if (isFetching) {
      return <p>Loading...</p>;
    } else if (isError) {
      return <p>Error: {error.message}</p>;
    }
    return null;
  };

  return (
    <>
      {renderLoadingOrError()}
      <AllCarUserTable />
    </>
  );
}